import type { useOrderList } from '@frontend/api';

import {
  MemoizedListTable,
  getPaginationCurrentPage,
} from 'components/listTablePage';

import { STICKY_LEFT_COLUMN_ID } from 'modules/orders/listPage/components/orderListTabs/const';
import type { OrderTableColumnConfig } from 'modules/orders/listPage/components/orderListTabs/types';
import { useOrderListSearchParams } from 'modules/orders/listPage/hooks';
import type { OrderListTabId } from 'modules/orders/listPage/types';

import { TableEmptyContent } from './components';
import { getRowLinkDestination } from './util';

export type OrderListTableProps = {
  columns: OrderTableColumnConfig[];
  orderListQuery: ReturnType<typeof useOrderList>;
  tabId: OrderListTabId;
};

export const OrderListTable = ({
  columns,
  orderListQuery,
  tabId,
}: OrderListTableProps) => {
  const { currentSort, searchParams, setPage, setSort } =
    useOrderListSearchParams();

  const paginationCurrentPage = getPaginationCurrentPage(searchParams.page);

  const { data: orderListData, isFetching: isFetchingOrderList } =
    orderListQuery;

  const orders = orderListData?.results ?? [];

  const paginationTotalItems = orderListData?.count ?? 0;

  const emphasizedDataRows = null;
  const emphasizedDataIsEmpty = true;

  return (
    <MemoizedListTable
      emphasizedDataRows={emphasizedDataRows}
      emphasizedDataIsEmpty={emphasizedDataIsEmpty}
      data={orders}
      isFetchingData={isFetchingOrderList}
      columns={columns}
      stickyColumnLeftId={STICKY_LEFT_COLUMN_ID}
      currentSort={currentSort}
      onSort={setSort}
      getRowLinkDestination={getRowLinkDestination}
      paginationCurrentPage={paginationCurrentPage}
      handlePageChange={setPage}
      paginationTotalItems={paginationTotalItems}
      emptyContent={<TableEmptyContent tabId={tabId} />}
    />
  );
};
